<script>
  import service from '../../../../domain/leiloes/services'
  export default{
    name: 'select-comitente',
    props: {
      value: {
        required: true
      }
    },
    data () {
      return {
        id: null,
        loadError: false,
        isLoading: false,
        comitentes: null
      }
    },
    computed: {
      model: {
        get () {
          return this.value === null ? '' : this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    mounted () {
      this.load()
    },
    destroyed () {
    },
    /* watch: {
      default: function (v) {
        console.log(v)
      }
    }, */
    methods: {
      load () {
        this.isLoading = true
        service.buscaComitentes().then((response) => {
          this.isLoading = false
          this.comitentes = response.data.comitentes
        })
          .catch((response) => {
            this.isLoading = false
            window.responseError(response)
            console.log(response)
          })
      }
    },
    components: {}
  }
</script>

<template>
  <div class="form-group">
    <label class="col-lg-2 control-label">Comitente</label>
    <div class="col-lg-10">
      <select v-model="model" class="form-control w-auto w-full-xs">
        <option disabled value="">{{ isLoading ? 'Carregando' : 'Selecione' }}</option>
        <option v-for="comitente in comitentes" :value="comitente.id" :key="comitente.id">{{ comitente.nome }} - {{ comitente.tipo == 1 ? comitente.cpf : comitente.cnpj }}{{ comitente.grupo ? ' - ' + comitente.grupo : '' }}</option>
      </select>
      <a v-if="loadError" class="btn text-danger" @click="load">Não foi possível carregar. Tente novamente</a>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// SelectComitente.vue?1a7e838e